module.exports = __webpack_public_path__ + "static/img/pic11.5cd72e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic11.png
// module id = Tjr+
// module chunks = 38